import React from 'react';
import operatingChain from '../../configs/operatingChain';

export const OperatingChainContext = React.createContext<string>(operatingChain);
